module.exports = __webpack_public_path__ + "img/277.2b36b4f3.png";